import {
    Component,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { EmployeeModel } from '../../../models';
import { LoggingService } from '../../../shared/services/logging';
import { Checkbox, MessageService, SelectItem } from '../../../shared';

@Component({
    selector: 'ef-send-purchases-presenter',
    templateUrl: './send-purchases-presenter.component.html',
    styleUrls: ['./send-purchases-presenter.component.scss'],
    standalone: false
})
export class SendPurchasesPresenterComponent implements OnChanges {
    @Input() public items: EmployeeModel[] = [];
    @Input() public resend = false;
    @Output() public SendPurchases = new ReplaySubject<{
        items: SelectItem[];
        sendImages: boolean;
    }>();
    @ViewChild('sendReceiptImages', { static: true })
    sendReceiptImages: Checkbox;
    public selectedEmployees: EmployeeModel[];
    constructor(
        private log: LoggingService,
        private messageService: MessageService
    ) {}
    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes &&
            changes.resend.currentValue != changes.resend.previousValue
        ) {
            this.selectedEmployees = [];
        }
    }
    public onSendPurchases(employees: SelectItem[]) {
        this.log.verbose({
            type: 'SendPurchasesPresenterComponent:onSendPurchases',
            employees
        });
        this.messageService.add({
            severity: 'info',
            summary: 'Sending Expenses...',
            detail: 'Send expenses in progress'
        });
        this.SendPurchases.next({
            items: employees,
            sendImages: this.sendReceiptImages.checked
        });
        this.selectedEmployees = [];
    }
}
